"use client";

import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import { GetLomdaResponseType } from "../../hooks/useGetLomda";
import { useState } from "react";
import { client } from "@/lib/hono";
import toast from "@/lib/toast";
import { useQueryClient } from "@tanstack/react-query";
import { LoaderCircle } from "lucide-react";
import { t } from "@/lib/localization";

export default function DuplicateLomdaButton({
    lomda,
}: {
    lomda: GetLomdaResponseType["data"];
}) {
    const [loading, setLoading] = useState(false);
    const queryClient = useQueryClient();

    const handleDuplicate = async () => {
        setLoading(true);

        try {
            const res = await (client.api.storage.lomda as any)[
                ":lomdaId"
            ].duplicate.$post({
                param: {
                    lomdaId: lomda.id,
                },
                json: {
                    newName: t("lomda-sheet.duplicate.default-name", undefined, {
                        name: lomda.name,
                    }),
                },
            });

            if (!res.ok) {
                const errorData = await res.json();
                console.error("Error duplicating lomda:", errorData);
                toast.error(t("toast.error.duplicate-lomda"), {
                    keyName: "toast.error.duplicate-lomda",
                });
                return;
            }

            const data = await res.json();
            console.log("Lomda duplicated successfully:", data);

            toast.success(t("toast.success.duplicate-lomda"), {
                keyName: "toast.success.duplicate-lomda",
            });

            // Invalidate queries to refresh the storage list
            queryClient.invalidateQueries({ queryKey: ["get-storage-files"] });
            queryClient.invalidateQueries({
                queryKey: ["get-storage-folders"],
            });
        } catch (error) {
            console.error("Error duplicating lomda:", error);
            toast.error(t("toast.error.default"), {
                keyName: "toast.error.default",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            onClick={handleDuplicate}
            disabled={loading}
            variant="secondary"
            size="sm"
        >
            {loading ? (
                <LoaderCircle className="size-3.5 me-2 animate-spin" />
            ) : (
                <Copy className="size-3.5 me-2" />
            )}
            {t("lomda-sheet.header.duplicate-btn", undefined, undefined)}
        </Button>
    );
}
